import { Dialog, Notify } from "vant";
import store from "../../store";
import apiAjax from "../../api"; //ajax组件
import { $uCommon } from "./uCommon";

/**
 * 消息弹窗
 * @param msg      内容
 * @param title    标题
 * @param fun      点击确定后回调
 * @param btnText  确定按钮文字
 * @param options  其他额外参数（参照对应ui文档）
 */
const $alertShow = function (msg, title, fun, options) {
  const defaultOptions = {
    title: title || "温馨提示",
    message: msg,
    //confirmButtonText: btnText,
    confirmButtonColor: "#04be02",
  };
  const actualOptions = Object.assign({}, defaultOptions, options);
  Dialog.alert(actualOptions).then(() => {
    if (fun) {
      fun();
    }
  });
};
/**
 * 消息提示
 * @param msg       内容
 * @param type      类型 主要通知:primary  成功通知:success  危险通知:danger  警告通知:warning
 * @param position  位置
 * @param options   其他额外参数（参照对应ui文档）
 */
const $toastShow = function (msg, type, position, options) {
  let option = {
    message: msg,
    position: position || "top",
  };
  if (!!type) {
    if (type.indexOf("#") == 0) {
      option.background = type;
    } else {
      option.type = type;
    }
  } else {
    option.type = "success";
  }
  const actualOptions = Object.assign({}, option, options);
  Notify(actualOptions);
};
/**
 * 确认提示框
 * @param content       内容
 * @param title         标题
 * @param confirm       确认回调
 * @param cancel        取消回调
 * @param confirmText   确认按钮文本
 * @param cancelText    取消按钮文本
 */
const $confirm = function (
  content,
  title,
  confirm,
  cancel,
  confirmText,
  cancelText
) {
  Dialog.confirm({
    title: title || "温馨提示",
    message: content,
    confirmButtonText: confirmText,
    confirmButtonColor: "#04be02",
    cancelButtonText: cancelText || "取消",
  })
    .then(() => {
      if (confirm) {
        confirm();
      }
    })
    .catch(() => {
      // on cancel
      if (cancel) {
        cancel();
      }
    });
};
/**
 * 显示loading
 * @param msg  loading提示
 */
const $loadingShow = function (msg) {
  let loadingSet = {
    msg: msg || "加载中...",
  };
  store.commit("setDataByName", { key: "loadingObj", val: loadingSet });
};
//隐藏loading
const $loadingHide = function () {
  store.commit("setDataByName", { key: "loadingObj", val: null });
};
/**
 * 全局post方法
 * 方式一：$post(url, postObj, isShowLoding, channel)
 * @returns {Promise<unknown>}
 * 方式二：$post(url, postObj, success, failure, isShowLoding, channel)
 * @returns null
 *
 * @param url      请求地址
 * @param postObj  请求参数
 * @param success  成功回调
 * @param failure  失败回调
 * @param isShowLoding  是否loading
 * @param channel  请求地址渠道
 */
const $Post = function () {
  let url, postObj, success, failure, isShowLoding, channel;
  url = arguments[0];
  postObj = arguments[1];
  if (arguments.length <= 4) {
    isShowLoding = arguments[2];
    channel = arguments[3];
  } else {
    success = arguments[2];
    failure = arguments[3];
    isShowLoding = arguments[4];
    channel = arguments[5];
  }
  if (isShowLoding) {
    $loadingShow("加载中");
  }
  //若请求头需要添加公共参数
  let userData = $uCommon.checklocalStorage("userdata");
  let headerObj = {};
  if (!!userData) {
    if (!!userData.token) {
      headerObj.Authorization = "Bearer " + userData.token;
    } else {
      headerObj.Authorization = "";
    }
  }
  return new Promise((resolve, reject) => {
    apiAjax.post(
      url,
      postObj,
      function (msg) {
        if (isShowLoding) {
          $loadingHide();
        }

        if (success) {
          success(msg);
        } else {
          resolve(msg);
        }
      },
      function (err) {
        if (isShowLoding) {
          $loadingHide();
        }

        if (failure) {
          failure(err);
        } else {
          reject(err);
        }
      },
      headerObj,
      channel
    );
  });
};

const $promiseAll = function (promiseList, success, fail) {
  Promise.all(promiseList.map((p) => p.catch((e) => e)))
    .then((res) => {
      if (success) {
        success(res);
      }
    })
    .catch((error) => {
      //console.log("error=>", error);
      if (fail) {
        fail(error);
      }
    });
};

const uGlobalFun = {
  $alertShow,
  $toastShow,
  $confirm,
  $loadingShow,
  $loadingHide,
  $Post,
  $promiseAll,
};

//const uGlobal = {
//  install(Vue) {
//    Vue.provide("$uGlobal", uGlobalFun);
//  },
//  uGlobal: uGlobalFun,
//};
export default uGlobalFun;
export const $uGlobal = uGlobalFun;
